import React, { FunctionComponent } from 'react';
import styles from './hero-with-video.module.scss';

import Section from '../section/section';

export interface IHeroWithVideoProps {
  children: IKontentItem[];
  videoUrl: {
    url: string;
  };
  dotsInBackground: boolean;
}

export const HeroWithVideo: FunctionComponent<IHeroWithVideoProps> = ({
  children,
  videoUrl: { url },
  dotsInBackground
}) => {
  return (
    <div
      className={`${styles.container} ${
        dotsInBackground ? styles.containerWithDots : null
      }`}
    >
      <div className={styles.itemsWrapper}>
        {children &&
          children.map((item: IKontentItem, i) => (
            <Section linkedItem={item} key={i} />
          ))}
      </div>
      <div className={styles.videoWrapper}>
        <video
          className={styles.videoBox}
          autoPlay
          loop
          muted
          src={url}
        ></video>
      </div>
    </div>
  );
};
